import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f3cf4cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border text-primary spinner-border-sm" }, null, -1))
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = ["id", "readonly", "disabled", "placeholder", "value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading && _ctx.ready)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([(_ctx.compact) ? '': 'form-floating', "mb-3"])
        }, [
          _createElementVNode("span", {
            type: "text",
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors, 'disabled': _ctx.readonly}]),
            id: _ctx.id
          }, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.options[0]), 1)
          ], 10, _hoisted_1),
          (_ctx.showLabel)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.id,
                class: "form-label"
              }, _toDisplayString(_ctx.label), 9, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1)
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.loading || !_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([(_ctx.compact) ? '': 'form-floating', "mb-3"])
        }, [
          _createElementVNode("select", {
            class: _normalizeClass(["form-select", {'is-invalid': _ctx.errors}]),
            id: _ctx.id,
            readonly: _ctx.readonly,
            disabled: _ctx.readonly,
            placeholder: _ctx.label,
            value: _ctx.modelValue,
            onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (name, optionId) => {
              return (_openBlock(), _createElementBlock("option", {
                value: optionId,
                key: optionId
              }, _toDisplayString(_ctx.getName(name)), 9, _hoisted_6))
            }), 128))
          ], 42, _hoisted_5),
          (_ctx.showLabel)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.id
              }, _toDisplayString(_ctx.label), 9, _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}